import { render, staticRenderFns } from "./AgeGatingModal.vue?vue&type=template&id=4e44fd4e&"
import script from "./AgeGatingModal.vue?vue&type=script&lang=js&"
export * from "./AgeGatingModal.vue?vue&type=script&lang=js&"
import style0 from "./AgeGatingModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports